// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --theme: #f15623;
  --theme-hover: #d94a1f;
  --theme-light: #fff4ef;
  --theme-border: #ffc9b3;
  --theme-glow: rgba(241, 86, 35, 0.18);
  --bg: #f7f7fb;
  --card: #ffffff;
  --border: #e8ecf1;
  --text: #0f172a;
  --muted: #64748b;
  --faint: #94a3b8;
  --acc: #16a34a;
  --acc-bg: #ecfdf3;
  --red: #dc2626;
  --radius: 12px;
  --radius-lg: 20px;
}

.home_page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 6px 16px 24px;
  box-sizing: border-box;
}

.home_page__header {
  width: 100%;
  flex-shrink: 0;
  padding-left: 4px;
  margin-bottom: 0;
}

.home_page__logo {
  display: block;
  height: 40px;
  width: auto;
  margin: 0;
}

.home_page__body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 26px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 12px 16px;
}

.home_page__title_block {
  text-align: center;
  max-width: 680px;
  width: 100%;
  margin: 0;
  padding: 0 8px;
}

.home_page__heading {
  font-size: 3.15rem;
  font-weight: 900;
  color: var(--text);
  letter-spacing: -0.03em;
  margin: 0 0 14px;
  line-height: 1.1;
}

.home_page__heading_theme {
  color: var(--theme);
}

.home_page__subheading {
  margin: 0 auto;
  font-size: 16px;
  font-weight: 400;
  color: var(--muted);
  line-height: 1.7;
  max-width: 640px;
}

.home_page__main {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.upload_card {
  position: relative;
  width: 100%;
  max-width: 420px;
  z-index: 1;
  background: var(--card);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 24px 26px 22px;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 8px 24px rgba(15, 23, 42, 0.06),
    0 24px 48px rgba(241, 86, 35, 0.06);
  overflow: hidden;
}

.home_page__hero {
  position: absolute;
  left: calc(50% + 268px);
  top: 50%;
  transform: translateY(-50%);
  max-width: 280px;
  max-height: 420px;
  width: auto;
  height: auto;
  object-fit: contain;
  pointer-events: none;
  filter: drop-shadow(0 12px 24px rgba(15, 23, 42, 0.08));
}

.upload_card__accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--theme) 0%, #ff8a5c 100%);
}

.upload_card__header {
  margin-bottom: 16px;
}

.upload_card__badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--theme);
  background: var(--theme-light);
  border: 1px solid var(--theme-border);
  padding: 5px 12px;
  border-radius: 100px;
}

.upload_zone {
  border: 2px dashed var(--border);
  border-radius: 14px;
  padding: 24px 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s, transform 0.15s;
  color: var(--muted);
  margin-bottom: 20px;
  background: linear-gradient(180deg, #fafbfc 0%, #f8fafc 100%);
}

.upload_zone:hover,
.upload_zone.drag_over {
  border-color: var(--theme);
  background: var(--theme-light);
  box-shadow: 0 0 0 4px var(--theme-glow);
  transform: translateY(-1px);
}

.upload_zone.has_file {
  border-color: var(--acc);
  border-style: solid;
  background: var(--acc-bg);
  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.1);
}

.upload_zone__icon_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin: 0 auto 12px;
  border-radius: 12px;
  background: var(--card);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  color: var(--theme);
}

.upload_zone.has_file .upload_zone__icon_wrap {
  color: var(--acc);
}

.upload_zone__icon {
  width: 28px;
  height: 28px;
}

.upload_zone__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  margin: 0 0 6px;
}

.upload_zone__hint {
  font-size: 13px;
  margin: 0;
  color: var(--faint);
}

.upload_filename {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  margin-top: 14px;
  padding: 8px 14px;
  border-radius: 8px;
  background: rgba(22, 163, 74, 0.1);
  color: #15803d;
}

.upload_filename__check {
  font-weight: 700;
}

.sample_download_link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--theme);
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 22px;
  font-family: inherit;
  transition: color 0.15s, gap 0.15s;
}

.sample_download_link:hover {
  color: var(--theme-hover);
  gap: 10px;
}

.internal_row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: linear-gradient(180deg, #fafbfc 0%, #f4f6f8 100%);
}

.internal_row input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--theme);
  cursor: pointer;
  flex-shrink: 0;
}

.internal_row label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--theme);
  cursor: pointer;
  flex: 1 1;
  -webkit-user-select: none;
          user-select: none;
}

.internal_pw_wrap {
  margin-bottom: 18px;
}

.internal_pw_wrap input {
  width: 100%;
  padding: 12px 14px;
  font-size: 13px;
  border: 1px solid var(--border);
  border-radius: 10px;
  outline: none;
  background: var(--card);
  color: var(--text);
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.internal_pw_wrap input:focus {
  border-color: var(--theme);
  box-shadow: 0 0 0 3px var(--theme-glow);
}

.internal_pw_wrap input.pw_error {
  border-color: var(--red);
}

.internal_pw_status {
  font-size: 11px;
  margin-top: 6px;
}

.internal_pw_status.ok {
  color: #16a34a;
}

.internal_pw_status.err {
  color: var(--red);
}

.btn_primary {
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(180deg, #f56a3d 0%, var(--theme) 50%, var(--theme-hover) 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.2s, opacity 0.15s;
  box-shadow:
    0 2px 4px rgba(241, 86, 35, 0.2),
    0 8px 20px rgba(241, 86, 35, 0.28);
}

.btn_primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow:
    0 4px 8px rgba(241, 86, 35, 0.25),
    0 12px 28px rgba(241, 86, 35, 0.35);
}

.btn_primary:active:not(:disabled) {
  transform: translateY(0);
}

.btn_primary:disabled {
  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.85;
}

.upload_error {
  color: var(--red);
  font-size: 13px;
  margin-top: 12px;
  padding: 10px 12px;
  background: #fef2f2;
  border-radius: 8px;
  border: 1px solid #fecaca;
}

.analyzer_embed {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #fff;
}

.analyzer_embed__frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

@media (max-width: 1024px) {
  .home_page__hero {
    left: calc(50% + 248px);
    max-width: 220px;
    max-height: 340px;
  }
}

@media (max-width: 900px) {
  .home_page {
    padding: 10px 12px 20px;
  }

  .home_page__header {
    padding-left: 2px;
  }

  .home_page__body {
    gap: 20px;
    padding-top: 0;
  }

  .home_page__heading {
    font-size: 2.35rem;
  }

  .home_page__subheading {
    font-size: 14px;
    line-height: 1.65;
  }

  .home_page__main {
    flex-direction: column;
    min-height: auto;
    gap: 32px;
  }

  .home_page__hero {
    position: static;
    transform: none;
    max-width: 200px;
    max-height: 300px;
  }

  .upload_card {
    max-width: 100%;
    padding: 22px 20px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/home_page.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB;;;uCAGqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iEAAiE;AACnE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gFAAgF;EAChF,mBAAmB;EACnB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;;EAEE,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,SAAO;EACP,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0FAA0F;EAC1F,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,2DAA2D;EAC3D;;sCAEoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B;;uCAEqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  --theme: #f15623;\n  --theme-hover: #d94a1f;\n  --theme-light: #fff4ef;\n  --theme-border: #ffc9b3;\n  --theme-glow: rgba(241, 86, 35, 0.18);\n  --bg: #f7f7fb;\n  --card: #ffffff;\n  --border: #e8ecf1;\n  --text: #0f172a;\n  --muted: #64748b;\n  --faint: #94a3b8;\n  --acc: #16a34a;\n  --acc-bg: #ecfdf3;\n  --red: #dc2626;\n  --radius: 12px;\n  --radius-lg: 20px;\n}\n\n.home_page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding: 6px 16px 24px;\n  box-sizing: border-box;\n}\n\n.home_page__header {\n  width: 100%;\n  flex-shrink: 0;\n  padding-left: 4px;\n  margin-bottom: 0;\n}\n\n.home_page__logo {\n  display: block;\n  height: 40px;\n  width: auto;\n  margin: 0;\n}\n\n.home_page__body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 26px;\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 12px 16px;\n}\n\n.home_page__title_block {\n  text-align: center;\n  max-width: 680px;\n  width: 100%;\n  margin: 0;\n  padding: 0 8px;\n}\n\n.home_page__heading {\n  font-size: 3.15rem;\n  font-weight: 900;\n  color: var(--text);\n  letter-spacing: -0.03em;\n  margin: 0 0 14px;\n  line-height: 1.1;\n}\n\n.home_page__heading_theme {\n  color: var(--theme);\n}\n\n.home_page__subheading {\n  margin: 0 auto;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--muted);\n  line-height: 1.7;\n  max-width: 640px;\n}\n\n.home_page__main {\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.upload_card {\n  position: relative;\n  width: 100%;\n  max-width: 420px;\n  z-index: 1;\n  background: var(--card);\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  border-radius: 16px;\n  padding: 24px 26px 22px;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 8px 24px rgba(15, 23, 42, 0.06),\n    0 24px 48px rgba(241, 86, 35, 0.06);\n  overflow: hidden;\n}\n\n.home_page__hero {\n  position: absolute;\n  left: calc(50% + 268px);\n  top: 50%;\n  transform: translateY(-50%);\n  max-width: 280px;\n  max-height: 420px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  pointer-events: none;\n  filter: drop-shadow(0 12px 24px rgba(15, 23, 42, 0.08));\n}\n\n.upload_card__accent {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--theme) 0%, #ff8a5c 100%);\n}\n\n.upload_card__header {\n  margin-bottom: 16px;\n}\n\n.upload_card__badge {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--theme);\n  background: var(--theme-light);\n  border: 1px solid var(--theme-border);\n  padding: 5px 12px;\n  border-radius: 100px;\n}\n\n.upload_zone {\n  border: 2px dashed var(--border);\n  border-radius: 14px;\n  padding: 24px 20px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s, transform 0.15s;\n  color: var(--muted);\n  margin-bottom: 20px;\n  background: linear-gradient(180deg, #fafbfc 0%, #f8fafc 100%);\n}\n\n.upload_zone:hover,\n.upload_zone.drag_over {\n  border-color: var(--theme);\n  background: var(--theme-light);\n  box-shadow: 0 0 0 4px var(--theme-glow);\n  transform: translateY(-1px);\n}\n\n.upload_zone.has_file {\n  border-color: var(--acc);\n  border-style: solid;\n  background: var(--acc-bg);\n  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.1);\n}\n\n.upload_zone__icon_wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  margin: 0 auto 12px;\n  border-radius: 12px;\n  background: var(--card);\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);\n  color: var(--theme);\n}\n\n.upload_zone.has_file .upload_zone__icon_wrap {\n  color: var(--acc);\n}\n\n.upload_zone__icon {\n  width: 28px;\n  height: 28px;\n}\n\n.upload_zone__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text);\n  margin: 0 0 6px;\n}\n\n.upload_zone__hint {\n  font-size: 13px;\n  margin: 0;\n  color: var(--faint);\n}\n\n.upload_filename {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  margin-top: 14px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  background: rgba(22, 163, 74, 0.1);\n  color: #15803d;\n}\n\n.upload_filename__check {\n  font-weight: 700;\n}\n\n.sample_download_link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--theme);\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  margin-bottom: 22px;\n  font-family: inherit;\n  transition: color 0.15s, gap 0.15s;\n}\n\n.sample_download_link:hover {\n  color: var(--theme-hover);\n  gap: 10px;\n}\n\n.internal_row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: linear-gradient(180deg, #fafbfc 0%, #f4f6f8 100%);\n}\n\n.internal_row input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--theme);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.internal_row label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--theme);\n  cursor: pointer;\n  flex: 1;\n  user-select: none;\n}\n\n.internal_pw_wrap {\n  margin-bottom: 18px;\n}\n\n.internal_pw_wrap input {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 13px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  outline: none;\n  background: var(--card);\n  color: var(--text);\n  box-sizing: border-box;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.internal_pw_wrap input:focus {\n  border-color: var(--theme);\n  box-shadow: 0 0 0 3px var(--theme-glow);\n}\n\n.internal_pw_wrap input.pw_error {\n  border-color: var(--red);\n}\n\n.internal_pw_status {\n  font-size: 11px;\n  margin-top: 6px;\n}\n\n.internal_pw_status.ok {\n  color: #16a34a;\n}\n\n.internal_pw_status.err {\n  color: var(--red);\n}\n\n.btn_primary {\n  width: 100%;\n  padding: 12px 16px;\n  background: linear-gradient(180deg, #f56a3d 0%, var(--theme) 50%, var(--theme-hover) 100%);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: transform 0.15s, box-shadow 0.2s, opacity 0.15s;\n  box-shadow:\n    0 2px 4px rgba(241, 86, 35, 0.2),\n    0 8px 20px rgba(241, 86, 35, 0.28);\n}\n\n.btn_primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow:\n    0 4px 8px rgba(241, 86, 35, 0.25),\n    0 12px 28px rgba(241, 86, 35, 0.35);\n}\n\n.btn_primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn_primary:disabled {\n  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 0.85;\n}\n\n.upload_error {\n  color: var(--red);\n  font-size: 13px;\n  margin-top: 12px;\n  padding: 10px 12px;\n  background: #fef2f2;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n}\n\n.analyzer_embed {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: #fff;\n}\n\n.analyzer_embed__frame {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n}\n\n@media (max-width: 1024px) {\n  .home_page__hero {\n    left: calc(50% + 248px);\n    max-width: 220px;\n    max-height: 340px;\n  }\n}\n\n@media (max-width: 900px) {\n  .home_page {\n    padding: 10px 12px 20px;\n  }\n\n  .home_page__header {\n    padding-left: 2px;\n  }\n\n  .home_page__body {\n    gap: 20px;\n    padding-top: 0;\n  }\n\n  .home_page__heading {\n    font-size: 2.35rem;\n  }\n\n  .home_page__subheading {\n    font-size: 14px;\n    line-height: 1.65;\n  }\n\n  .home_page__main {\n    flex-direction: column;\n    min-height: auto;\n    gap: 32px;\n  }\n\n  .home_page__hero {\n    position: static;\n    transform: none;\n    max-width: 200px;\n    max-height: 300px;\n  }\n\n  .upload_card {\n    max-width: 100%;\n    padding: 22px 20px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
